import api from "./client";

// AI Testing Agent API
export const aiTestingAgentAPI = {
  // Get all testing agents
  getAllAgents: async (clientId) => {
    try {
      const response = await api.get("/api/v1/agents", {
        params: { client_id: clientId },
      });
      if (response && response.data) {
        return response.data;
      } else {
        console.warn("Unexpected API response format:", response);
        return { data: [] };
      }
    } catch (error) {
      if (error.response?.status === 401) {
        if (error.response?.data?.error === "Token has been revoked") {
          throw new Error(
            "Your session has been revoked. Please log in again."
          );
        } else if (error.response?.data?.error === "Token expired") {
          throw new Error("Your session has expired. Please log in again.");
        }
        throw new Error("Authentication failed. Please log in again.");
      }
      throw error;
    }
  },

  // Get a specific testing agent
  getAgent: async (id, clientId) => {
    try {
      const response = await api.get(`/api/v1/agents/${id}`, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to view agent details");
      }
      throw error;
    }
  },

  // Create a new testing agent
  createAgent: async (agentData, clientId) => {
    try {
      const response = await api.post("/api/v1/agents", agentData, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      console.error("Create agent error:", error);
      console.error("Error response:", error.response?.data);
      if (error.response?.status === 401) {
        throw new Error("Please log in to create an agent");
      }
      throw error;
    }
  },

  // Update a testing agent
  updateAgent: async (id, agentData, clientId) => {
    try {
      const response = await api.put(`/api/v1/agents/${id}`, agentData, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to update an agent");
      }
      throw error;
    }
  },

  // Delete a testing agent
  deleteAgent: async (id, clientId) => {
    try {
      const response = await api.delete(`/api/v1/agents/${id}`, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to delete an agent");
      }
      throw error;
    }
  },

  // Get runs for a specific agent
  getAgentRuns: async (agentId, clientId) => {
    const response = await api.get(`/api/v1/agents/${agentId}/runs`, {
      params: { client_id: clientId },
    });
    return response.data;
  },
};
